// extracted by mini-css-extract-plugin
export default {"MainDiv":"CompanyHistory_MainDiv__THE7A"};